// locationEmbedded?: string | RegExp | (string | RegExp)[];
// locationTransformer?: (url: string, blank: boolean) => string;

/**
 * 基座应用用于接管页面跳转地址的函数，提供该函数时将忽略 `locationEmbedded` 规则。
 * @param url 目标地址
 * @param blank 是否为新开页面
 * @returns 基座应用重定向的跳转地址，不做修改则原样传回 `url` 参数
 */

/**
 * 基座应用用来声明可以接管的 URL 列表，支持 `glob 匹配` 与 `正则表达式`。
 * 示例： "/boilerplate/**"、 /^\/boiler\w+\/.+/
 */
const LOCATION_EMBEDDED = ['/material/**', '/launch/**'];

export { LOCATION_EMBEDDED };
